var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviousSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-circle-left",
    clipPath: "url(#clip0_709_117180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 39.375C9.29688 39.375 0.625 30.7031 0.625 20C0.625 9.29688 9.29688 0.625 20 0.625C30.7031 0.625 39.375 9.29688 39.375 20C39.375 30.7031 30.7031 39.375 20 39.375ZM22.2578 28.1562L16.3594 22.5H30.625C31.6641 22.5 32.5 21.6641 32.5 20.625V19.375C32.5 18.3359 31.6641 17.5 30.625 17.5H16.3594L22.2578 11.8438C23.0156 11.1172 23.0312 9.90625 22.2891 9.16406L21.4297 8.3125C20.6953 7.57812 19.5078 7.57812 18.7812 8.3125L8.41406 18.6719C7.67969 19.4062 7.67969 20.5938 8.41406 21.3203L18.7812 31.6875C19.5156 32.4219 20.7031 32.4219 21.4297 31.6875L22.2891 30.8359C23.0312 30.0938 23.0156 28.8828 22.2578 28.1562Z",
    fill: "#008060",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_117180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousSlice);
export default __webpack_public_path__ + "static/media/previous_slice.2eca27e6a282e2bf7d4199e479190936.svg";
export { ForwardRef as ReactComponent };